import { required, optional, array, obj } from 'AppReact/schema';

export const file = {
  url: required('string'),
  content_type: required('string'),
  uuid: required('string')
}

const history = {
  description: required('string'),
  datetime: required('jsDate'),
}

export const event = {
  id: required('integer'),
  created_by: required('string'),
  datetime: required('jsDate'),
  event_name: required('string'),
  description: optional('string'),
  attachments: array(obj(file)),
  description_history: array(obj(history))
}
